import request from "@/utils/request";

export const getUser = ({ uuid, params } = {}) =>
  request.get(`/users/${uuid}`, {
    params,
  });
